const Browser = ({children,theme}) => {

    const bg = theme === 'light' ? {outer:'bg-white border border-slate-200',inner:'bg-slate-200'} : {outer:'bg-slate-900',inner:'bg-slate-800'}

    return <div className={bg.outer+' shadow-xl rounded-lg lg:rounded-2xl relative overflow-hidden flex flex-col'}>
        <div className={bg.inner+' gap-2 flex items-center p-5 h-10'}>
            <div className='bg-slate-400 w-2 h-2 rounded'></div>
            <div className='bg-slate-400 w-2 h-2 rounded'></div>
            <div className='bg-slate-400 w-2 h-2 rounded'></div>
        </div>
        
        {children}
    
        
    </div>
}
export default Browser